/* VH Collections (vh-collection-hero / vh-collection-more). PRESENTATION ONLY: no cart, customer or network calls.
   - sort menu submits on change (Shopify's own ?sort_by=); the Sort button covers JS-off
   - cards-per-row toggle flips data-cols on our toolbar; the CSS does the rest
   - member band moves into the theme's product grid after the 4th card, and comes back if a filter re-renders the grid
   - the big word shrinks to fit its column; entrance motion and reveals via the shared kit (GSAP, reduced-motion aware) */
(function () {
  var root = document.getElementById('vh-collection');
  if (!root || root.dataset.vhInit) return;
  root.dataset.vhInit = '1';
  root.classList.add('is-js');

  /* sort */
  var sort = root.querySelector('[data-vh-collection-sort]');
  if (sort) {
    var sel = sort.querySelector('select');
    sel.addEventListener('change', function () { if (sort.requestSubmit) sort.requestSubmit(); else sort.submit(); });
  }

  /* cards per row */
  var bar = root.querySelector('.vh-collection-bar'), dens = root.querySelector('[data-vh-collection-dens]');
  if (bar && dens) {
    dens.hidden = false;
    var KEY = 'vh-collection-cols', saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    var set = function (n) {
      bar.dataset.cols = n;
      Array.prototype.forEach.call(dens.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.dataset.d === n ? 'true' : 'false'); });
    };
    if (saved === '2') set('2');
    dens.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-d]'); if (!b) return;
      set(b.dataset.d);
      try { localStorage.setItem(KEY, b.dataset.d); } catch (err) {}
    });
  }

  /* member band: stays below the product grid (never inserted into main-collection's grid, which theme scripts own) */
  var mem = document.querySelector('[data-vh-collection-mem]');
  if (mem) {
    mem.classList.add('vh-page');
    var slot = document.querySelector('.vh-collection-mem-slot');
    if (slot && mem.parentNode !== slot) slot.appendChild(mem);
  }

  /* big word fits its column (measured, never clipped) */
  var word = root.querySelector('.vh-collection-word'), span = word && word.firstElementChild;
  var fit = function () {
    if (!word || !span) return;
    word.style.fontSize = '';
    var max = word.clientWidth, w = span.getBoundingClientRect().width;
    if (w > max && max > 0) word.style.fontSize = (parseFloat(getComputedStyle(word).fontSize) * max / w * 0.97) + 'px';
  };
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var rt = null;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 80); });

  /* motion */
  var go = function () {
    if (!window.VHK) { root.classList.remove('vh-collection-pre'); return; }
    VHK.withGsap(function (ok) {
      if (!ok) { root.classList.remove('vh-collection-pre'); return; }
      var copy = root.querySelectorAll('.vh-collection-crumbs, .vh-collection-copy > *');
      var pk = root.querySelectorAll('.vh-collection-pk img'), tag = root.querySelector('.vh-collection-tag');
      gsap.set([].concat([].slice.call(copy), [].slice.call(pk), tag ? [tag] : []), {autoAlpha: 0});
      root.classList.remove('vh-collection-pre');
      gsap.fromTo(copy, {autoAlpha: 0, y: 30}, {autoAlpha: 1, y: 0, duration: 1, stagger: 0.07, ease: 'power3.out', delay: 0.1, clearProps: 'opacity,visibility,transform'});
      gsap.fromTo(root.querySelectorAll('.vh-collection-word span'), {yPercent: 110}, {yPercent: 0, duration: 0.9, ease: 'power3.out', delay: 0.15, clearProps: 'transform'});
      if (pk.length) gsap.fromTo(pk, {y: 90, autoAlpha: 0, rotation: function (i) { return [0, -14, 14][i] || 0; }}, {y: 0, autoAlpha: 1, rotation: 0, duration: 1, stagger: 0.09, ease: 'back.out(1.3)', delay: 0.3, clearProps: 'all'});
      if (tag) gsap.fromTo(tag, {autoAlpha: 0, y: -10}, {autoAlpha: 1, y: 0, duration: 0.5, delay: 0.7, clearProps: 'opacity,visibility,transform'});
    });
    var more = document.getElementById('vh-collection-more');
    if (more) VHK.reveals(more);
  };
  if (window.VHK) go(); else window.addEventListener('load', go);
})();
